import { useQuery } from 'react-query'
import { getTagsQuery } from '../api/tagsQueries'

function useTags() {
  return useQuery(getTagsQuery)
}

export default useTags
